import axios from "services/api";
import { API3_HOST } from 'helpers/urlHelper';
import React, { useState } from 'react';
import { Button, Form, FormControl, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

/***
 * Helper modal for creating dashboard items
 */
export default function CreateModal(props) {
  const navigate = useNavigate();
  const [name, setName] = useState('');

  const create = () => {
    axios({
      method: 'post',
      url: `${API3_HOST}${props.endpoint}`,
      data: { name: name }
    })
      .then(result => {
        if (result.data.id) {
          navigate(`${props.redirect}${result.data.id}`); // navigate to endpoint
        }
      })
      .catch(err => {
        console.log('CreateModal failed to load data', err);
      });
  };

  return (
    <Modal
      show={props.show}
      onHide={() => {}}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Name</Form.Label>
          <FormControl
            placeholder="Name"
            aria-label="Name"
            value={name}
            onChange={event => {
              setName(event.target.value);
            }}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Access</Form.Label>
          <Form.Select aria-label="">
            <option value="private">Private</option>
            <option value="public">Public</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => {
            create();
          }}
        >
          Create
        </Button>
        <Button variant="danger" onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

CreateModal.propTypes = {
  endpoint: PropTypes.string,
  redirect: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool,
  onHide: PropTypes.func
};
